export default __webpack_public_path__ + "2658ff6.png";